import Chip from "./Chip";

export {
    Chip as default,
};
